import { useSelector } from "react-redux"

export const useShopifyOnlyUser = () => {
  const balance = useSelector((state) => state?.balance?.balance)
  return {
    isShopifyOnlyUser: balance?.is_shopify_only_processor,
    isShopifyDefaultProcessor: balance?.add_funds_options?.default === "shopify"
  }
}
